// 素材类型
export enum MARKET_TYPE {
  SEND_PRODUCT = 'SEND_PRODUCT', // 产品
  SEND_POSTER = 'SEND_POSTER', // 海报
  SEND_ACTIVITY = 'SEND_ACTIVITY', // 活动
  SEND_ARTICLE = 'SEND_ARTICLE', // 资讯
  SEND_FESTIVAL_CARE = 'SEND_FESTIVAL_CARE', // 节点关怀
  SEND_MOMENTS = 'SEND_MOMENTS', // 朋友圈神器
  SEND_MORNING_PAPER = 'SEND_MORNING_PAPER', // 早报
  SEND_EVENING_PAPER = 'SEND_EVENING_PAPER', // 晚报
}

// 素材信息

export const MARKET_IFON = {
  [MARKET_TYPE.SEND_PRODUCT]: {
    title: '选择产品',
    placeholder: '请输入产品名称或代码搜索',
    text: '产品',
  },
  [MARKET_TYPE.SEND_POSTER]: {
    title: '选择海报',
    placeholder: '按海报名称搜索',
    text: '海报',
  },
  [MARKET_TYPE.SEND_ACTIVITY]: {
    title: '选择活动',
    placeholder: '请输入活动名称进行搜索',
    text: '活动',
  },
  [MARKET_TYPE.SEND_ARTICLE]: {
    title: '选择文章',
    placeholder: '输入文章标题搜索',
    text: '文章',
  },
  [MARKET_TYPE.SEND_FESTIVAL_CARE]: {
    title: '选择节点关怀',
    placeholder: '输入标题搜索',
    text: '节点关怀',
  },
  [MARKET_TYPE.SEND_MOMENTS]: {
    title: '选择朋友圈',
    placeholder: '输入标题搜索',
    text: '朋友圈',
  },
};
